import axioscommon from './axios-common';
import authHeader from './auth-header';

const defaultSettings = require('@/settings.js');
const API_URL = defaultSettings.apiUrl + '/api/status/';

class StatusService {
    // extra fields
    getStatus(onlyActive) {
        if (onlyActive) {
            return axioscommon.get(API_URL, { headers: authHeader() });
        }
        return axioscommon.get(API_URL + 'getAll', { headers: authHeader() });
    }
    getFirstActiveStatus() {
        return axioscommon.get(API_URL + 'first', { headers: authHeader() });
    }

    saveStatus(data) {
        return axioscommon.post(API_URL, data, { headers: authHeader() });
    }
    updateStatus(data) {
        return axioscommon.put(API_URL, data, { headers: authHeader() });
    }
}

export default new StatusService();
